// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1518":"4c28caa534500df1","4301":"934c0a48452e7c26","5428":"71bd255d92650e21","9812":"77d918eb677edb22"}[chunkId] + ".js";
};